import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import Container from "@mui/material/Container";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@mui/material";
import Layout from "./Layout";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

const Account = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [locale, setLocale] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
      ]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  const handleLogout = () => {
    axios
      .get("/api/auth/signout/" + context.user.id)
      .then((response) => {
        context.updateUserState(null);
        navigate("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const updatedUser = {
      ...context.user,
      locale: locale || context.user.locale,
    };

    axios
      .post(process.env.REACT_APP_API_URL + "/api/user", 
        updatedUser
      )
      .then((response) => {
        if (response.status === 200) {
          context.updateUserState(response.data.user);
        } else {
          context.updateUserState(null);
        }
      })
      .catch((error) => {
        // TODO handle UI error
        console.log("login error: ");
        console.log(error);
      });
  };

  const handleChange = (event) => {
    setLocale(event.target.value, ()=>{ handleSubmit; });
  };

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" component="div">
                <FormattedMessage
                  id="app.header.account.label"
                  defaultMessage="Ayuda"
                />
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <FormControl fullWidth>
                    <InputLabel id="settingsLangLabel">{intl.formatMessage({ id: "app.account.locale.label" })}</InputLabel>
                    <Select
                      name="locale"
                      labelId="settingsLangLabel"
                      id="settingsLang"
                      value={(locale)?locale:context.user.locale}
                      label={intl.formatMessage({ id: "app.account.locale.label" })}
                      onChange={handleChange}
                      native={true}
                    >
                      <option value={"en"}>English</option>
                      <option value={"es"}>Español</option>
                    </Select>
                  </FormControl>
                </CardContent>
                <CardActions>
                  <Button variant="outlined" size="small" onClick={handleSubmit}>
                    <FormattedMessage id="app.ring.form.save.label" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
              <Button onClick={handleLogout} variant="outlined" color="error">
                <FormattedMessage
                  id="app.logout.label"
                  defaultMessage="Logout"
                />
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Layout>
  );
};

export default Account;
